module.exports = __webpack_public_path__ + "static/media/YF77_0.994d5667.jpg";